namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmStat extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmStatReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmStatObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmStatObj());
            this.detailObj.createBase({
                contentName: "detailAdmStat",
                contentCaption: "jres:29802073", 
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmStat", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmStatObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmStatReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["stat_txt"]
        }

        setSxsDetail(): string {
            return (this.data.stat) ? this.data.stat.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmStatSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmStat.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                if (err.responseJSON.exception.containsNonFatal != true)
                    this.showBaseError();
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmStat", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmStat.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.stat_txt) ? this.data.stat_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("stat");
            this.MakeField("stat_txt");
            this.MakeField("stat_zkr");
            this.MakeField("stat_txt_orig");
            this.MakeField("stat_zkr_orig");
            this.MakeSelectField("svetadil", Gordic.Prefabs.Select.gincsve(), { model: "model.svetadil=value.svetadil" });
            this.MakeField("stat_csu");
            this.MakeSelectField("priz_iban", Gordic.Prefabs.Select.gincpan(), { model: "model.priz_iban=value.priz_an" });
            this.MakeSection("jres:33000085") //RC 33000085 : K�dy podle Standart� st�tn�ho informa�n�ho syst�mu
            this.MakeField("stat_sis_aa");
            this.MakeField("stat_sis_aaa");
            this.MakeField("stat_sis_nnn");
            this.MakeSection("jres:33000086") //RC 33000086 : P��znaky zem� EU
            this.MakeSelectField("priz_eu", Gordic.Prefabs.Select.gincpan(), {
                model: "model.priz_eu=value.priz_an",
                change: (ev, changeObj) => {
                    if (this.editMode == true) {
                        if (changeObj.value) {
                            if (!Array.isArray(changeObj.value))
                                if (changeObj.value.priz_an == 1)
                                    this.cnt.findFields("kod_zeme_eu").gfield("option", { disabled: false });
                                else
                                    this.cnt.findFields("kod_zeme_eu").gfield("option", { disabled: true });
                        }
                    } else
                        this.cnt.findFields("kod_zeme_eu").gfield("option", { disabled: true });
                }
            });
            this.MakeField("kod_zeme_eu");
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });

        }
    }
}